<form [formGroup]="changePasswordForm" class="changePassForm">
    <div *ngIf="showTick" class="resetsuccess">
        <div class="sucsmsg-header">
            <img class="logo-img" src="assets/img/success-icon.png">
            <div class="sucess-styl">Success The password has been changed successfully! </div>
        </div>
        <div style="clear:both"></div>
        <div style="display: flex;justify-content: center;align-items: center;margin-top:1%"><a class="loginLink"
                (click)="redirectLink('login')" style="margin-top:5%;margin-bottom:15%">
                Back to Login</a></div>
    </div>

    <div *ngIf="failureTick" class="resetfailure">
        <div class="failurenotifier">
            <img class="logo-img" src="assets/img/logo/Critical.png">
            <div>Error Your password reset was unsuccessful</div>
        </div>
        <div style="clear:both"></div>
        <div style="display: flex;justify-content: center;align-items: center;"> <label class="reset">Please try again
                by generating a new ‘Reset Password’ link</label></div>
        <div style="clear:both"></div>
        <div style="display: flex;justify-content: center;align-items: center;"> <a class="forgetLink"
                (click)="redirectLink('forget-password')">Back to Forgot Password Page</a></div>

        <div style="display: flex;justify-content: center;align-items: center;margin-top:15%"><label
                class="reset">Trouble logging in? &nbsp; </label><a class="forgetLink"> Contact Support</a></div>
    </div>
    <div class="main-content" fxLayout="column" *ngIf="isLoggedIn || showForm">

        <div class="form-group-header" *ngIf="isLoggedIn" [ngStyle]="{'margin-top' : isLoggedIn ? '6%' : ''}">
            <div class="form-group">
                <div class="label-head">
                    <img src="assets/img/logo/lock.png" style="height: 15px;margin-right: 6px;">
                    <label class="label-sty" for="oldPassword">Old Password</label>
                </div>

                <mat-form-field floatLabel="never" appearance="outline">
                    <input class="inp-sty" matInput [type]="hideOld ? 'password' : 'text'" formControlName="oldPassword"
                        required>
                    <mat-icon matSuffix (click)="hideOld = !hideOld" style="cursor: pointer;opacity: 0.6;">
                        {{hideOld ? 'visibility_off' : 'visibility'}}
                    </mat-icon>

                    <mat-error class="err-sty"
                        *ngIf="changePasswordForm.get('oldPassword').valid && changePasswordForm.get('oldPassword').touched">
                        Old Password is required
                    </mat-error>

                </mat-form-field>
            </div>
        </div>
        <div class="form-group-header">
            <div class="form-group">
                <div class="label-head">
                    <img src="assets/img/logo/lock.png" style="height: 15px;margin-right: 6px;">
                    <label class="label-sty" for="newPassword">New Password</label>
                </div>
                <mat-form-field floatLabel="never" appearance="outline">
                    <input class="inp-sty" matInput [type]="hideNew ? 'password' : 'text'" formControlName="newPassword"
                        required>
                    <mat-icon matSuffix (click)="hideNew = !hideNew" style="cursor: pointer;opacity: 0.6;">
                        {{hideNew ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                    <mat-error class="err-sty">
                        <span *ngIf="changePasswordForm.invalid&&changePasswordForm?.controls.newPassword?.errors?.required">
                            New Password is required 
                        </span>
                    </mat-error>

                </mat-form-field>

                <app-password-strength required minlength="6" maxlength="18" minStrength="2"
                    [touched]='changePasswordForm?.controls.newPassword?.pristine'
                    [(ngModel)]="changePasswordForm?.value.newPassword" formControlName='notInUse'
                    (publishStength)='getStrength($event)' *ngIf='changePasswordForm?.controls.newPassword.value'
                    [hidden]='!changePasswordForm?.value.newPassword' class="mt-1 passwordstrength">
                </app-password-strength>

                <ng-container *ngIf='changePasswordForm?.controls.newPassword.value'>
                    <img class="pwd-tick"
                        [ngStyle]="{'margin-top' : isLoggedIn ? '-21%' : '-21%',  'margin-bottom' : isLoggedIn ? '17%' : '18%'}"
                        src="assets/img/info_weak.png" *ngIf='strength.strength == 0 || strength.strength == 1' />
                    <img class="pwd-tick" src="assets/img/info_strong.png"
                        [ngStyle]="{'margin-top' : isLoggedIn ? '-21%' : '-21%',  'margin-bottom' : isLoggedIn ? '17%' : '18%'}"
                        *ngIf='strength.strength == 4' />
                    <img class="pwd-tick" src="assets/img/info_avg.png"
                        [ngStyle]="{'margin-top' : isLoggedIn ? '-21%' : '-21%',  'margin-bottom' : isLoggedIn ? '17%' : '18%'}"
                        *ngIf=' strength.strength == 2 || strength.strength == 3' />
                </ng-container>
                <div *ngIf='changePasswordForm?.controls.newPassword.value'>

                    <div class="passError2 f-12" [hidden]='!(strength.strength == 0 || strength.strength == 1)'
                        [ngStyle]="{'margin-left' : isLoggedIn ? '69.8%' : '70.3%'}" fxFlexAlign="none">
                        <p class="font-weight-bold">Password is too weak. Try something longer.</p>
                        <span>
                            <ng-container *ngIf='strength.containsSpecial == false'>• Must contain one special character
                                <br></ng-container>
                            <ng-container *ngIf='strength.containsUpper == false'>• Must contain at least one Upper case
                                <br></ng-container>
                            <ng-container *ngIf='strength.containsLower == false'>• Must contain at least one Lower case
                                <br></ng-container>
                            <ng-container *ngIf='strength.containsDigit == false'>• Must contain at least one digit <br>
                            </ng-container>
                            <ng-container *ngIf='strength.containsEightChars == false'> • Must contain at least 8 chars
                                <br></ng-container>
                            • New password must not match any of the
                            previous 12 passwords <br>
                            • Must not be the same as User ID’s <br>
                            • Passwords cannot have leading or trailing spaces<br>
                            <ng-container *ngIf='strength.moreThanEighteenChar == false'> • Must not be more than 18 chars
                                <br></ng-container>
                        </span>
                       
                    </div>

                    <div class="passError2 f-12" [hidden]="!(strength.strength == 2 || strength.strength == 3)"
                        [ngStyle]="{'margin-left' : isLoggedIn ? '69.8%' : '70.3%'}" fxFlexAlign="none">
                        <p class="font-weight-bold">Humm average password strength. Try something longer and special
                            charaters.
                        </p>
                        <span>
                            <ng-container *ngIf='strength.containsSpecial == false'>• Must contain one special character
                                <br></ng-container>
                            <ng-container *ngIf='strength.containsUpper == false'>• Must contain at least one Upper case
                                <br></ng-container>
                            <ng-container *ngIf='strength.containsLower == false'>• Must contain at least one Lower case
                                <br> </ng-container>
                            <ng-container *ngIf='strength.containsDigit == false'>• Must contain at least one digit <br>
                            </ng-container>
                            <ng-container *ngIf='strength.containsEightChars == false'> • Must contain at least 8 chars
                                <br></ng-container>
                            • New password must not match any of the
                            previous 12 passwords<br>
                            <ng-container *ngIf='strength.moreThanEighteenChar == true'> • Must not be more than 18 chars
                                <br></ng-container>
                        </span>
                    </div>
                    <div *ngIf="strength.strength == 4" class="passError1 f-14"
                        [ngStyle]="{'margin-left' : isLoggedIn ? '69.8%' : '70.3%' , 'margin-top' : isLoggedIn ? '-17%' : '-17.4%'}">
                        Strong password strength. Just don’t forget it.
                    </div>
                </div>

            </div>

        </div>
        <div class="form-group-header">
            <div class="form-group">
                <div class="label-head" style="margin-top: 22px;">
                    <img src="assets/img/logo/lock.png" style="height: 15px;margin-right: 6px;">
                    <label class="label-sty" for="confirmPassword">Confirm New Password</label>
                </div>
                <mat-form-field floatLabel="never" appearance="outline">
                    <input class="inp-sty" matInput [type]="hideConfirm ? 'password' : 'text'"
                        formControlName="confirmPassword" required>
                    <mat-icon matSuffix (click)="hideConfirm = !hideConfirm" style="cursor: pointer;opacity: 0.6;">
                        {{hideConfirm ? 'visibility_off' : 'visibility'}}
                    </mat-icon>
                    <mat-error class="err-sty">
                        <span
                            *ngIf="changePasswordForm.invalid&&changePasswordForm?.controls.confirmPassword?.errors?.MatchPassword">Password
                            and confirm password do not match</span>
                        <span
                            *ngIf="changePasswordForm.invalid&&changePasswordForm?.controls.confirmPassword?.errors?.required">
                            Confirm Password is required!</span>
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row" style="padding-bottom: 8px;margin-left:14.5%;margin-top: 22px;">
            <div class="col-md-4">

                <button class="btn-sty cancel-btn-sty" style="color: #0A4D79 !important; " (click)="closeDialog()">
                    Cancel</button>


            </div>
            <div class="col-md-4" style="margin-left:4%">
                <button mat-raised-button (click)="onFormSubmit(changePasswordForm.value,changePasswordForm)"
                    [class.btn-sty]="!changePasswordForm.valid || strength.strength < 4"
                    [disabled]="!changePasswordForm.valid || strength.strength < 4">
                    Save</button>

            </div>
        </div>

    </div>
</form>